module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/performance/pages/home/asset/empty.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/performance/pages/home/asset/empty.png
// module id = 782
// module chunks = 438